import { ar, enUS } from "date-fns/locale";
import { compareAsc, formatDistanceToNow } from "date-fns";

import { Milestone } from "../types/service.type";
import { MilestoneStatusEnum } from "../enum/service.enum";

type MilestoneResult = {
  milestone: Milestone | null;
  timeUntilDue: string;
  isFuture: boolean;
};

export const getUpcomingMilestone = (milestones: Milestone[], locale: string = "en"): MilestoneResult => {
  if (!milestones?.length) {
    return { milestone: null, timeUntilDue: "", isFuture: false };
  }

  const dateLocale = locale === "ar" ? ar : enUS;
  const now = new Date();

  const milestonesWithDates = milestones.map((m) => ({
    ...m,
    dueDate: new Date(m.deliveryDueDate),
  }));

  const sortedMilestones = milestonesWithDates.sort((a, b) => compareAsc(a.dueDate, b.dueDate));

  const futureMilestones = sortedMilestones.filter((m) => m.dueDate > now);
  const pastMilestones = sortedMilestones.filter((m) => m.dueDate <= now);

  let relevantMilestone: {
    dueDate: Date;
    deliveryDueDate: string;
    id: number;
    name: string;
    paymentDueDate: string | null;
    status: MilestoneStatusEnum;
  };
  let isFuture = false;

  if (futureMilestones.length > 0) {
    relevantMilestone = futureMilestones[0];
    isFuture = true;
  } else if (pastMilestones.length > 0) {
    relevantMilestone = pastMilestones[pastMilestones.length - 1];
    isFuture = false;
  } else {
    return { milestone: null, timeUntilDue: "", isFuture: false };
  }

  const timeUntilDue = formatDistanceToNow(relevantMilestone.dueDate, {
    addSuffix: true,
    locale: dateLocale,
  });

  return {
    milestone: milestones.find((m) => m.id === relevantMilestone.id) || null,
    timeUntilDue,
    isFuture,
  };
};
